import bem from 'utils/bem';

export const block = bem('share-form');
